import { Snackbar, Alert } from '@mui/material'
import PropTypes from 'prop-types'
import React from 'react'

/**
 * @description Renders a custom Snackbar component.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} props.open - Whether the Snackbar is open or not.
 * @param {function} props.onClose - Callback function to handle Snackbar close event.
 * @param {string} props.vertical - The vertical position of the Snackbar.
 * @param {string} props.horizontal - The horizontal position of the Snackbar.
 * @param {string} props.severity - The severity level of the Alert component inside the Snackbar.
 * @param {string} props.variant - The variant of the Alert component inside the Snackbar.
 * @param {string} props.message - The message to be displayed inside the Alert component.
 * @returns {React.Element} The rendered Snackbar component.
 */
const MySnackbar = ({ open, onClose, vertical, horizontal, severity, variant, message, ...props }) => {

    return (
        <Snackbar
            open={open}
            onClose={onClose}
            autoHideDuration={6000}
            anchorOrigin={{ vertical, horizontal }}
            {...props}
        >
            <Alert onClose={onClose} severity={severity} variant={variant}>
                {message}
            </Alert>
        </Snackbar>
    )
}

MySnackbar.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    vertical: PropTypes.oneOf(['top', 'bottom']).isRequired,
    horizontal: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
    severity: PropTypes.oneOf(['warning', 'error', 'info', 'success']).isRequired,
    variant: PropTypes.oneOf(['filled', 'outlined']),
    message: PropTypes.string.isRequired
}

export { MySnackbar as Snackbar }
